/**
 * Correspondance route paramètre document ↔ type_document_id (aligné sur document.component typeDocumentIdMap).
 * À ajuster si les ids diffèrent en base.
 */
export const PARAMETRE_TYPE_DOCUMENT_VENTE = {
    devis: 7,
    commandeClient: 8,
    bonSortie: 9,
    bonLivraison: 10,
    facture: 11,
    avoir: 15
} as const;

export const PARAMETRE_TYPE_DOCUMENT_ACHAT = {
    commandeFournisseur: 12,
    bonReception: 13,
    factureFournisseur: 14,
    inventaire: 17
} as const;

/** Types vente gérés dans « Référence du document » (menu par type). */
export const REFERENCE_DOC_TYPE_MENU: ReadonlyArray<{
    key: keyof typeof PARAMETRE_TYPE_DOCUMENT_VENTE;
    typeDocumentId: number;
    label: string;
    defaultPrefix: string;
}> = [
    { key: 'devis', typeDocumentId: PARAMETRE_TYPE_DOCUMENT_VENTE.devis, label: 'Devis', defaultPrefix: 'Devis' },
    {
        key: 'commandeClient',
        typeDocumentId: PARAMETRE_TYPE_DOCUMENT_VENTE.commandeClient,
        label: 'Commande client',
        defaultPrefix: 'Cmd'
    },
    {
        key: 'bonSortie',
        typeDocumentId: PARAMETRE_TYPE_DOCUMENT_VENTE.bonSortie,
        label: 'Bon de sortie',
        defaultPrefix: 'BS'
    },
    {
        key: 'bonLivraison',
        typeDocumentId: PARAMETRE_TYPE_DOCUMENT_VENTE.bonLivraison,
        label: 'Bon de livraison',
        defaultPrefix: 'BL'
    },
    {
        key: 'facture',
        typeDocumentId: PARAMETRE_TYPE_DOCUMENT_VENTE.facture,
        label: 'Facture',
        defaultPrefix: 'Fact'
    },
    { key: 'avoir', typeDocumentId: PARAMETRE_TYPE_DOCUMENT_VENTE.avoir, label: 'Avoir', defaultPrefix: 'Avoir' }
];

/** Libellé français affiché à côté du champ « Label » (paramètres document vente). */
const VENTE_DOC_TYPE_LABEL_BY_ID: Record<number, string> = {
    [PARAMETRE_TYPE_DOCUMENT_VENTE.devis]: 'Devis',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.commandeClient]: 'Commande client',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.bonSortie]: 'Bon de sortie',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.bonLivraison]: 'Bon de livraison',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.facture]: 'Facture',
    [PARAMETRE_TYPE_DOCUMENT_VENTE.avoir]: 'Avoir'
};

export function getVenteDocumentTypeLabel(typeDocumentId: number): string {
    return VENTE_DOC_TYPE_LABEL_BY_ID[typeDocumentId] ?? 'Document';
}

/** Map documentType string (document.component) → type_document_id. */
export const DOCUMENT_TYPE_TO_ID: Record<string, number> = {
    DEVIS: PARAMETRE_TYPE_DOCUMENT_VENTE.devis,
    'COMMANDE CLIENT': PARAMETRE_TYPE_DOCUMENT_VENTE.commandeClient,
    'BON DE SORTIE': PARAMETRE_TYPE_DOCUMENT_VENTE.bonSortie,
    'BON DE LIVRAISON': PARAMETRE_TYPE_DOCUMENT_VENTE.bonLivraison,
    FACTURE: PARAMETRE_TYPE_DOCUMENT_VENTE.facture,
    AVOIR: PARAMETRE_TYPE_DOCUMENT_VENTE.avoir,
    'COMMANDE FOURNISSEUR': PARAMETRE_TYPE_DOCUMENT_ACHAT.commandeFournisseur,
    'BON RECEPTION': PARAMETRE_TYPE_DOCUMENT_ACHAT.bonReception,
    'FACTURE FOURNISSEUR': PARAMETRE_TYPE_DOCUMENT_ACHAT.factureFournisseur,
    INVENTAIRE: PARAMETRE_TYPE_DOCUMENT_ACHAT.inventaire
};

export function parseModelesReferenceMap(raw: unknown): Record<string, number> {
    if (raw == null || raw === '') {
        return {};
    }
    let obj: unknown = raw;
    if (typeof raw === 'string') {
        try {
            obj = JSON.parse(raw);
        } catch {
            return {};
        }
    }
    if (obj == null || typeof obj !== 'object' || Array.isArray(obj)) {
        return {};
    }
    const out: Record<string, number> = {};
    for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
        const tid = Number(k);
        const mid = Number(v);
        if (Number.isFinite(tid) && tid > 0 && Number.isFinite(mid) && mid > 0) {
            out[String(Math.floor(tid))] = Math.floor(mid);
        }
    }
    return out;
}

export function resolveModeleReferenceForType(
    modelesReference: unknown,
    typeDocumentId: number | null | undefined,
    fallbackModeleReference: number | null | undefined
): number | null {
    const map = parseModelesReferenceMap(modelesReference);
    const tid = Number(typeDocumentId);
    if (Number.isFinite(tid) && tid > 0) {
        const fromMap = map[String(Math.floor(tid))];
        if (fromMap != null) {
            return fromMap;
        }
    }
    if (fallbackModeleReference != null) {
        const n = Number(fallbackModeleReference);
        if (Number.isFinite(n) && n > 0) {
            return Math.floor(n);
        }
    }
    return null;
}
